import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_empresa/empresa-compras";

export const Route = createFileRoute("/_authenticated/empresa-compras")({
  head: () => ({
    meta: [
      { title: "Compras — Milky Moo Palmares" },
      { name: "description", content: "Área de compras e recebimento." },
      { property: "og:title", content: "Compras — Milky Moo Palmares" },
      { property: "og:description", content: "Área de compras e recebimento." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
